import axios from "axios";
import { axiosRequest } from "../api";
import { API_PATH } from "../../constants";

export const ProviderSakhadService = {
  sakhadSendOtp(data: any) {
    return axiosRequest("POST", API_PATH.PROVIDER_SAKHAD.SEND_OTP, data);
  },
  sakhadVerifyOtp(data: any) {
    return axiosRequest("POST", API_PATH.PROVIDER_SAKHAD.VERIFY_OTP, data);
  },
  sakhadLogin(data: any) {
    return axiosRequest("POST", API_PATH.PROVIDER_SAKHAD.LOGIN, data);
  },
  sakhadConfirm(data: any) {
    return axiosRequest("POST", API_PATH.PROVIDER_SAKHAD.CONFIRM, data);
  },
  sakhadGetCaptcha(data: any) {
    return axiosRequest("POST", API_PATH.PROVIDER_SAKHAD.GET_CAPTCHA, data);
  },
  sakhadInquiryPrescription(data: any) {
    return axiosRequest(
      "POST",
      API_PATH.PROVIDER_SAKHAD.INQUIRY_PRESCRIPTION,
      data,
    );
  },
  getAllServiceListByType(data: any) {
    return axiosRequest(
      "POST",
      API_PATH.PROVIDER_SAKHAD.GET_ALL_SERVICE_LIST_BY_TYPE,
      data,
    );
  },

  getSakhadVerifyCaptcha(data: any) {
    return axiosRequest("POST", API_PATH.PROVIDER_SAKHAD.VERIFY_CAPTCHA, data);
  },

  sakhadProvicerIsLoggedIn() {
    return axiosRequest("POST", API_PATH.PROVIDER_SAKHAD.PROVIDER_IS_LOGGED_IN);
  },
  sakhadGetSubHistory(data: any) {
    return axiosRequest("POST", API_PATH.PROVIDER_SAKHAD.GET_SUB_HISTORY, data);
  },
  // sakhadLogout() {
  //   const token = localStorage.getItem("token"); // use your actual key
  //   return axiosRequest(
  //     "POST",
  //     API_PATH.PROVIDER_SAKHAD.LOGOUT,
  //     {},
  //     { "HD-Authorization": token },
  //   );
  // },

  sakhadPrintPrescription(data: any) {
    return axios({
      method: "POST",
      url: API_PATH.PROVIDER_SAKHAD.PRINT_PRESCRIPTION,
      data: data,
      responseType: "blob",
    });
  },
  sakhadGetServiceByTypeAndCode(data: any) {
    return axiosRequest(
      "POST",
      API_PATH.PROVIDER_SAKHAD.GET_SERVICE_BY_TYPE_AND_CODE,
      data,
    );
  },
  sakhadGetAllConsumptionListByShape(data: any) {
    return axiosRequest(
      "POST",
      API_PATH.PROVIDER_SAKHAD.GET_ALL_CONSUMPTION_LIST_BY_SHAPE,
      data,
    );
  },

  sakhadGetAllConsumptionInstructionListByShape(data: any) {
    return axiosRequest(
      "POST",
      API_PATH.PROVIDER_SAKHAD.GET_ALL_CONSUMPTION_INSTRUCTION_BY_SHAPE,
      data,
    );
  },
};
